<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">智能终端测试解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          随着互联网+产业的蓬勃发展，智能终端的崛起，无论是移动终端制造商、移动通信运营商以及移动互联网内容服务商，都面临着新技术、新业务、新服务不断涌现，商用进程不断加快的局面。<br>
          当前基于5G核心技术的移动传输网络已开发出来，未来支持的设备除了智能手机，还要支持智能手表、健身手环、智能投影仪、智能家庭设备等。智能终端产业链正经历着快速的发展期。通信标准不断地更新和修订、智能手机功能推陈出新、各种通信协议认证越来越复杂繁琐。终端厂商、移动通信运营商、移动互联网内容服务商以及用户对终端产品的质量要求越来越高，终端测试技术面临巨大挑战。<br>
          橡诺科技作为领先的创新型技术服务提供商，致力于优质的测试服务与高质量的软件交付。我们一直在研究行业先进的测试方法，改进测试流程，推出端到端一站式智能终端测试解决方案，提高测试生产力。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          智能终端测试<br>
          橡诺科技与终端厂商有着密切的合作关系，共同建立最高效的终端测试ODC实验室合作模式。智能终端测试从改进测试方法入手，提供产品测试计划、产品测试方案设计、产品测试用例开发、测试执行验证、各种外部认证的预测试服务。主要测试类别包括：<br>
          1.白盒测试方法包括静态分析（Java：Checkstyle、PMD、Findbugs）、代码review，覆盖测试（Junit）、动态分析四个过程；<br>
          2.黑盒测试方法包括业务功能测试、协议一致性测试、新特性测试、性能及稳定性测试、KPI测试、第三方应用测试、本地化/全球化测试、运营商预入网测试、运营商验证测试、运营商定制应用测试、IOT测试、路测、认证测试等。<br>
          智能终端自动化测试<br>
          自动化测试能够有效提高测试效率，一些手工无法覆盖或者工作量非常大的测试内容，都可以通过自动化测试轻而易举实现。充分发挥自动化测试的优势，将基础用例自动生成、业务用例自由组合、重复工作自动化，这是橡诺科技自动化测试解决方案的核心竞争力。<br>
          橡诺科技终端自动化测试平台是基于Appium测试框架，集成Testng，Reportng，用Java语言开发的一套兼容Android和IOS两大手机操作系统的能自动生成测试脚本，高效执行测试的自动化测试平台。它通过上传应用包，自动控件识别，提供简化的控件数据验证组合页面即用例创建，后台自动生成测试脚本，调度用户指定的设备执行用例，输出测试报告。我们的理念是简化测试界面，封装技术细节，提供步骤可控、设备可选、结果可查的测试系统。
          <div class="img"><img src="@/assets/img/solution/7/1.png"><img src="@/assets/img/solution/7/2.png"></div>
        </div>
        <div class="title-sub">能力优势</div>
        <div class="text">
          灵活多样的测试服务能力<br>
          提供产品整体测试计划、方案、流程、过程管理与监控以及各类测试服务：<br>
          测试管理体系咨询服务<br>
          性能测试专项服务<br>
          安全性测试专项服务<br>
          测试技能培训服务<br>
          特色测试工具研发服务<br>
          测试平台建设服务<br>
          完善高效的移动终端测试体系架构<br>
          我们拥有独立的测试能力中心和测试架构、专项测试团队，为测试实施过程中遇到的疑难杂症提供了有力的保障。运用了统一规范的测试流程和测试用例设计方法，在测试生命周期进行高级同行评审，全面质量控制，并及时对测试过程进行优化。
          <div class="img"><img src="@/assets/img/solution/7/3.png"></div>
          全面的终端测试经验<br>
          拥有超过3000人的终端测试团队<br>
          跨平台测试服务：Android、IOS<br>
          多国语言服务：英语、日语、韩语以及多种语种<br>
          客户涵盖国内外各大移动设备制造商、运营商、芯片制造商以及移动互联网服务商
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          提供灵活多样的一站式测试外包解决方案，协助移动互联网产业链终端设备制造商、芯片商、运营商以及内容服务商从繁琐浩大的测试需求中解脱出来，专注自己的产品创新，同时减少投入、提高工作效率；<br>
          提供全方位的测试服务，高质量交付，协助客户实现有效的风险降低和成本控制；<br>
          输送经验丰富的测试人员，并给员工定制培训专项测试技能，为客户提供强有力的技术保障。
        </div>
        <div class="title-sub">典型客户</div>
        <div class="text">
          智能终端制造企业<br>
          电信运营商<br>
          移动应用软件开发商
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>